import HeaderSwitchComponent from  '../site_interfaces/headers/header_switch'

class AiHeader extends HeaderSwitchComponent {

}

export default AiHeader;



// WEBPACK FOOTER //
// ./src/layout/AiHeader.js